// 封装请求方法
import requset from '@/utils/request.js'

export const getNewsScrollList = (data) =>　{
    return requset({
        url:'/xwzx/news/scroll/list',
        method:'GET',
        params:data
    })
}
export const getNewsList = (data) =>　{
    return requset({
        url:'/xwzx/news/information/list',
        method:'GET',
        params:data
    })
}
// 首页运营位：首页大横幅 / 24H新刊速递左侧活动（独立于资讯）
export const getHomeShowcase = (data) =>　{
    return requset({
        url:'/xwzx/home/showcase/site',
        method:'GET',
        params:data
    })
}
export const getConfigList = (data) =>　{
    return requset({
        url:'/xwzx/system/config/list',
        method:'GET',
        data
    })
}
// 供需入驻（接口路径仍是 /company/info，表 tb_company_info）
export const saveListing = (data) =>　{
    return requset({
        url:'/xwzx/company/info',
        method:'POST',
        data
    })
}
export const submitCompany = saveListing
// 企业信息 / 大厅挂牌
export const getEnterpriseList = (data) =>　{
    return requset({
        url:'/xwzx/enterprise/info/list',
        method:'GET',
        params: data
    })
}
export const getCompanyList = getEnterpriseList
export const getBookList = (data) =>　{
    return requset({
        url:'/xwzx/book/info/list',
        method:'GET',
        params:data
    })
}
export const getEnterpriseTypeList = (data) =>　{
    return requset({
        url:'/xwzx/enterprise/info/getType',
        method:'GET',
        data
    })
}
export const getCompanyTypeList = getEnterpriseTypeList
export const getArticleDetail = (data) =>　{
    return requset({
        url:'/xwzx/news/information/' + data,
        method:'GET',
    })
}
export const getLiveList = (data) =>　{
    return requset({
        url:'/xwzx/live/info/list',
        method:'GET',
        params:data
    })
}
export const getEnterpriseDetail = (data) =>　{
    return requset({
        url:'/xwzx/enterprise/info/' + data,
        method:'GET',
    })
}
export const getCompanyDetail = getEnterpriseDetail
export const getDatasetList = (data) =>　{
    return requset({
        url:'/xwzx/dataset/info/list',
        method:'GET',
        params: data
    })
}
export const getDatasetDetail = (data) =>　{
    return requset({
        url:'/xwzx/dataset/info/' + data,
        method:'GET',
    })
}
export const getTradeList = (data) =>　{
    return requset({
        url:'/xwzx/dataTrade/info/list',
        method:'GET',
        params: data
    })
}
export const getTradeDetail = (data) =>　{
    return requset({
        url:'/xwzx/dataTrade/info/' + data,
        method:'GET',
    })
}
export const addExpertInfo = (data) =>　{
    return requset({
        url:'/xwzx/expert/info',
        method:'POST',
        data
    })
}
export const addExpertInfoDetail = (data) =>　{
    return requset({
        url:'/xwzx/expert/info/' + data,
        method:'GET'
    })
}
export const getExpertList = (data) =>　{
    return requset({
        url:'/xwzx/expert/info/list',
        method:'GET',
        params:data
    })
}
export const articleInfoList = (data) =>　{
    return requset({
        url:'/xwzx/article/info/list',
        method:'GET',
        params:data
    })
}
// 数据专家访谈录
export const interviewList = (data) =>　{
    return requset({
        url:'/xwzx/interview/record/list',
        method:'GET',
        params:data
    })
}
// /dev-api/interview/record/{id}
export const interviewNameDetail = (data) =>　{
    return requset({
        url:'/xwzx/interview/record/' + data,
        method:'GET',
    })
}
// 数据
export const applicationScenario = () =>　{
    return requset({
        url:'/xwzx/applicationScenario/list',
        method:'GET',
    })
}